import { useState, useEffect } from "react";
import { portalClienteCollabs, portalClienteChamadas } from "../api/functions";

const BRAND = { primary: "#0FC9C5", card: "#1e293b", border: "#334155" };

export default function Collabs({ usuario, onEntrarSala }) {
  const [collabs, setCollabs] = useState([]);
  const [chamadas, setChamadas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [collabSelecionado, setCollabSelecionado] = useState(null);

  useEffect(() => {
    const carregar = async () => {
      try {
        const [c, ch] = await Promise.all([
          portalClienteCollabs({ empresa_id: usuario.empresa_id, usuario_id: usuario.id }),
          portalClienteChamadas({ empresa_id: usuario.empresa_id, usuario_id: usuario.id }),
        ]);
        setCollabs(c.collabs || []);
        setChamadas(ch.chamadas || []);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    carregar();

    // Polling a cada 30s para detectar chamadas ao vivo
    const interval = setInterval(async () => {
      try {
        const ch = await portalClienteChamadas({ empresa_id: usuario.empresa_id, usuario_id: usuario.id });
        setChamadas(ch.chamadas || []);
      } catch {}
    }, 30000);
    return () => clearInterval(interval);
  }, [usuario]);

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "300px", color: "#64748b" }}>
      <div style={{ textAlign: "center" }}><div style={{ fontSize: "32px", marginBottom: "12px" }}>⏳</div><p>Carregando collabs...</p></div>
    </div>
  );

  const getChamadasDoCollab = (collabId) => chamadas.filter(ch => ch.collab_id === collabId);
  const getChamadaAoVivo = (collabId) => getChamadasDoCollab(collabId).find(ch => ch.status === "em_andamento");

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <div style={{ marginBottom: "8px" }}>
        <h2 style={{ color: "#f1f5f9", fontSize: "20px", fontWeight: "700", marginBottom: "4px" }}>🤝 Seus Collabs</h2>
        <p style={{ color: "#64748b", fontSize: "13px" }}>Projetos e colaborações vinculadas à sua empresa</p>
      </div>

      {collabs.length === 0 ? (
        <div style={{ background: BRAND.card, border: `1px solid ${BRAND.border}`, borderRadius: "16px", padding: "40px", textAlign: "center" }}>
          <div style={{ fontSize: "40px", marginBottom: "12px" }}>🤝</div>
          <p style={{ color: "#64748b" }}>Nenhum collab vinculado ainda.</p>
        </div>
      ) : (
        collabs.map((collab, i) => {
          const chamadaViva = getChamadaAoVivo(collab.id);
          const historicoReuniao = getChamadasDoCollab(collab.id).filter(ch => ch.status === "encerrada");
          const aberto = collabSelecionado === collab.id;

          return (
            <div key={i} style={{ background: BRAND.card, border: `1px solid ${chamadaViva ? "#16a34a" : BRAND.border}`, borderRadius: "16px", overflow: "hidden", transition: "border-color 0.3s" }}>
              {/* Header do collab */}
              <div style={{ padding: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }} onClick={() => setCollabSelecionado(aberto ? null : collab.id)}>
                <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                  <div style={{ width: "44px", height: "44px", borderRadius: "12px", background: chamadaViva ? "#052e16" : "#0f172a", border: `1px solid ${chamadaViva ? "#16a34a" : "#334155"}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px" }}>
                    {chamadaViva ? "📹" : "🤝"}
                  </div>
                  <div>
                    <div style={{ color: "#f1f5f9", fontWeight: "700", fontSize: "15px" }}>{collab.nome}</div>
                    <div style={{ color: "#64748b", fontSize: "12px", marginTop: "2px" }}>{collab.tipo || "Collab"} · {historicoReuniao.length} reunião(ões) realizada(s)</div>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  {chamadaViva && (
                    <button onClick={(e) => { e.stopPropagation(); onEntrarSala(chamadaViva.id); }} style={{
                      background: "#16a34a", color: "#fff", border: "none", padding: "8px 16px",
                      borderRadius: "8px", fontWeight: "700", cursor: "pointer", fontSize: "13px",
                      display: "flex", alignItems: "center", gap: "6px"
                    }}>
                      <span style={{ width: "8px", height: "8px", background: "#86efac", borderRadius: "50%", display: "inline-block" }} />
                      Entrar ao vivo
                    </button>
                  )}
                  <span style={{ color: "#475569", fontSize: "18px" }}>{aberto ? "▲" : "▼"}</span>
                </div>
              </div>

              {/* Histórico de reuniões */}
              {aberto && (
                <div style={{ borderTop: `1px solid ${BRAND.border}`, padding: "16px 20px", background: "#0f172a" }}>
                  <h4 style={{ color: "#94a3b8", fontSize: "12px", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "12px" }}>Histórico de Reuniões</h4>
                  {historicoReuniao.length === 0 ? (
                    <p style={{ color: "#475569", fontSize: "13px" }}>Nenhuma reunião encerrada ainda.</p>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                      {historicoReuniao.slice(0, 10).map((ch, j) => (
                        <div key={j} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", background: "#1e293b", borderRadius: "10px", border: "1px solid #334155" }}>
                          <div>
                            <div style={{ color: "#e2e8f0", fontSize: "13px", fontWeight: "500" }}>{ch.titulo}</div>
                            <div style={{ color: "#64748b", fontSize: "12px", marginTop: "2px" }}>
                              📅 {new Date(ch.data_inicio).toLocaleDateString('pt-BR')}
                              {ch.duracao_minutos ? ` · ${ch.duracao_minutos} min` : ""}
                            </div>
                          </div>
                          <span style={{ padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "600", background: "#1a2e1a", color: "#4ade80", border: "1px solid #16a34a40" }}>encerrada</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
}
